function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from 'modules/Layout';
import Account from 'modules/Account';
function action({ route }) {
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        component: /*#__PURE__*/ _jsxs(Layout.components.DashboardLayout, {
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: "text--h1 mb-6",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Layout.messages.headers.dashboard))
                }),
                /*#__PURE__*/ _jsx(Account.components.WelcomeStatement, {})
            ]
        })
    };
}
export default action;
